/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { getHandlerVersionCaching, postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import {
    StorageLocation,
    Effect,
    Setter,
    TechwiseOffice,
    CreateTechwiseOfficeRequest,
    VersionedPagination,
} from "../../utils/Interfaces";
import { AxiosResponse } from "axios";
import { store } from "../../app/store";
import { setExistingTechwiseOffices } from "./techwiseOfficesSlice";

export function createTechwiseOffice(
    payload: CreateTechwiseOfficeRequest,
    dispatch: Dispatch<AnyAction>,
    onTechwiseOfficeCreated: Effect
) {
    postHandler(
        "/api/locations/offices/create",
        payload,
        dispatch,
        () => onTechwiseOfficeCreated(),
        stdErrHandlerFactory(dispatch),
        () => {}
    );
}

export function updateTechwiseOffices(dispatch: Dispatch<AnyAction>, setLoading: Setter<boolean>) {
    getHandlerVersionCaching<StorageLocation>(
        "/api/locations/offices/list",
        store.getState().locations.existingTechwiseOfficesVersion,
        dispatch,
        (response: AxiosResponse<VersionedPagination<TechwiseOffice>>) => {
            dispatch(setExistingTechwiseOffices(response.data));
        },
        () => {},
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
